import * as React from "react";

import { ITheme } from "@fluentui/react/lib/Styling";
import { Toggle } from "@fluentui/react/lib/Toggle";

import { dataUniqueId, getOuterContainerClassName } from "@1js/acui-common";
import { AppThemeConsumer } from "@1js/acui-theme";

import { AppToggleProps } from "./AppToggle.Props";
import { getStyles, getStylesBasedOnAppColors } from "./AppToggle.styles";

export class AppToggle extends React.PureComponent<AppToggleProps, {}> {
  constructor(props: AppToggleProps) {
    super(props);
  }

  public render() {
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <div
            className={getOuterContainerClassName()}
            data-unique-id={dataUniqueId(this.props)}
          >
            <Toggle
              {...this.props}
              styles={getStyles(
                theme,
                this.props,
                getStylesBasedOnAppColors(
                  theme,
                  this.props.disabled,
                  this.props.checked,
                  this.props.appColors
                )
              )}
            />
          </div>
        )}
      </AppThemeConsumer>
    );
  }
}
